.country-code,
.phone-code {
  font-family: var(--font-family-secondary-mono);
}

.country-code {
  width: calc(8 * var(--spacer));
}

.phone-code {
  width: calc(6 * var(--spacer));
  display: flex;
  justify-content: end;
}

.tooltip {
  width: 100%;
  font-size: var(--body-size-large);

  span {
    font-family: var(--font-family-secondary);
  }
}
